<template>
	<b-container class="pt-4">
		<h1>Blog</h1>
		<p>
			Hvis du gerne vil holde dig opdateret omkring hvad der rører sig i SkvizBiz, så kan du læse mere her.
		</p>
		<hr>
		<b-form-input v-model="search.text" class="mb-0" type="search" placeholder="Søg i blogindlæg" autocomplete="off"></b-form-input>
		<div class="mb-3">
			<b-badge v-for="(tag, index) in search.tags" :key="tag" variant="info" class="mr-1 clickable" @click="search.tags.splice(index, 1)">{{tag}} ×</b-badge>
		&nbsp;</div>

		<div class="blog-overview-container">
			<b-card v-for="post in posts" :key="post.path" class="mb-4">
				<template v-slot:header>
					<nuxt-link :to="post.path" style="text-decoration: none; color: inherit;">
						<h2 v-html="post.title"></h2>
					</nuxt-link>
				</template>
				<p v-if="post.description" style="white-space: pre-line;" v-html="post.description">{{post.description}}</p>
				<p v-else-if="post.excerpt" style="white-space: pre-line;" v-html="post.excerpt">{{post.excerpt}}</p>
				<p v-if="post.tags"><b-badge v-for="tag in post.tags" :key="tag" variant="info" class="mr-1 clickable" @click="add_tag_to_filter(tag)">{{tag}}</b-badge></p>
				<p class="mb-0 d-flex justify-content-between align-items-end">
					<b-button variant="outline-primary" size="sm" :to="post.path">Læs&nbsp;mere...</b-button>
					<small style="text-align: right;"><post-timestamp :post="post" /></small>
				</p>
			</b-card>
		</div>
		<hr>
		<h2>Alle tags:</h2>
		<p v-if="tags"><b-badge v-for="tag in tags" :key="tag" variant="info" class="mr-1 clickable" @click="add_tag_to_filter(tag)">{{tag}}</b-badge></p>
	</b-container>
</template>

<script>
	import {
		BContainer,
		BFormInput,
		BBadge,
		BCard,
		BButton,
	} from "bootstrap-vue";
	import PostTimestamp from "~/components/PostTimestamp.vue";
	// import { parseISO, isFuture, format, formatDistanceToNow, formatRelative } from "date-fns";

	export default {
		name: "pages-blog",
		components: {
			BContainer,
			BFormInput,
			BBadge,
			BCard,
			BButton,

			PostTimestamp,
		},
		data() {
			return {
				posts: [],
				tags: [],
				search: {
					text: "",
					tags: [],
				}
			};
		},
		async asyncData({ $content }) {
			let posts = await $content("blog", {deep: true})
				.without(["body"])
				.sortBy("createdAt", "desc")
				.where({status: {$ne: "draft"}})
				.fetch()

			// posts = posts.filter(post => {
			// 	let release = (post.published && parseISO(post.published)) ? parseISO(post.published) : new Date(post.createdAt);
			// 	if (release >= new Date()) {
			// 		return false;
			// 	}
			// 	return true;
			// })

			let tags = [... new Set(posts.flatMap(post => post.tags))].sort();

			return {
				posts,
				tags,
			};
		},
		methods: {
			async fetch_posts() {
				let posts = this.$content("blog", {deep: true})
					.without(["body"])
					.sortBy("createdAt", "desc")
					.where({status: {$ne: "draft"}})

				if (this.search.text) {
					posts.search(this.search.text);
				}
				posts = await posts.fetch();

				if (this.search.tags.length) {
					posts = posts.filter(post => {
						if (post.tags && post.tags.filter(tag => this.search.tags.includes(tag)).length == this.search.tags.length) {
							return true;
						}
						return false;
					});
				}

				// posts = posts.filter(post => {
				// 	let release = (post.published && parseISO(post.published)) ? parseISO(post.published) : new Date(post.createdAt);
				// 	if (release >= new Date()) {
				// 		return false;
				// 	}
				// 	return true;
				// })

				return posts;
			},
			add_tag_to_filter(tag) {
				if (!this.search.tags.includes(tag)) {
					this.search.tags.push(tag)
				}
			},
		},
		watch: {
			search: {
				deep: true,
				async handler(search) {
					this.posts = await this.fetch_posts();
				},
			},
		},
	};
</script>

<style scoped>
	@media (min-width: 768px) {
		.blog-overview-container {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-left: -10px;
			margin-right: -10px;
		}
		.blog-overview-container > * {
			flex: 1 0 calc(50% - 20px);
			margin-left: 10px;
			margin-right: 10px;
		}
		.blog-overview-container > :first-child {
			flex-basis: calc(100% - 20px);
	}
	}
</style>